import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import type { Language } from '../i18n.js';
import { Logo } from './Logo.js';
import { Stepper } from './Stepper.js';

export function AppShell({
  children,
  language,
  step,
}: {
  children: ReactNode;
  language: Language;
  step?: 1 | 2 | 3 | 4 | 5;
}) {
  return (
    <div className="app-shell">
      <header className="topbar">
        <Link to="/" aria-label="Refindi">
          <Logo className="logo" />
        </Link>
        <div className="topbar-actions">
          <span className="product-label">LOST &amp; FOUND</span>
        </div>
      </header>
      <main className="main-content">
        {step ? <Stepper current={step} language={language} /> : null}
        {children}
      </main>
      <footer className="footer">
        © {new Date().getFullYear()} Refindi · <Link to="/legal/privacy">Privacy</Link> ·{' '}
        <Link to="/legal/terms">Terms</Link>
      </footer>
    </div>
  );
}
